import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import { subscribeAlert } from '../utils/functions/globalDialog';
import StatusCodeBadge from './StatusCodeBadge';
import { translateHttpStatus } from '../utils/functions/httpStatusThai';

// แทน window.alert() — mount ครั้งเดียวที่ root (index.js) เหมือน GlobalErrorDialog
const GlobalAlertDialog = () => {
  const [message, setMessage] = useState(null);
  const [status, setStatus] = useState(null);

  useEffect(
    () => subscribeAlert((msg, code) => {
      setMessage(msg);
      setStatus(code ?? null);
    }),
    [],
  );

  const variant = status != null ? 'error' : 'success';

  return (
    <Dialog
      open={!!message}
      onClose={() => setMessage(null)}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <StatusCodeBadge code={status} variant={variant} />
        แจ้งเตือน
      </DialogTitle>
      <DialogContent>
        {variant === 'error' ? (() => {
          const mainText = translateHttpStatus(status);
          return (
            <>
              <DialogContentText
                style={{ whiteSpace: 'pre-wrap', fontSize: '1rem', fontWeight: 600, color: '#212121' }}
              >
                {mainText}
              </DialogContentText>
              {message && message !== mainText && (
                <DialogContentText
                  style={{ whiteSpace: 'pre-wrap', fontSize: '0.72rem', color: '#9e9e9e', marginTop: 10 }}
                >
                  {message}
                </DialogContentText>
              )}
            </>
          );
        })() : (
          <DialogContentText style={{ whiteSpace: 'pre-wrap' }}>
            {message}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setMessage(null)} variant="contained">
          ตกลง
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GlobalAlertDialog;
